module.exports = __webpack_public_path__ + "img/bg-hex-dark.c4ebe47.png";